var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25859 5.06436C8.05045 4.95355 7.78614 4.98584 7.61074 5.16124L2.16123 10.6107C1.94626 10.8257 1.94626 11.1743 2.16123 11.3892C2.37621 11.6042 2.72476 11.6042 2.93973 11.3892L7.99999 6.32899L13.0603 11.3893C13.2752 11.6042 13.6238 11.6042 13.8388 11.3893C14.0537 11.1743 14.0537 10.8257 13.8388 10.6108L8.38925 5.16125C8.38925 5.16124 8.38925 5.16124 8.38924 5.16124C8.34966 5.12166 8.30555 5.08937 8.25859 5.06436Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLess);
export default __webpack_public_path__ + "static/media/expandLess.2ef56e2a2638313751f499a0454eb274.svg";
export { ForwardRef as ReactComponent };